<template>
    <dialog-selector
        class="mallitem-dialog-selector"
        ref="dialogSelector"
        title="选择商品"
        width="923px" 
        v-on="$listeners"
        v-bind="$attrs"
        :data="groupData"
        :props="{ label: 'name', groupId: 'subCategory' }"
        search-placeholder="输入首字母或关键字检索商品"
        :filter-node-method="filterNode"
        @click-sidebar-item="onClickSidebarItem"
        @select-change="onSelectChange">
        <template v-slot:node="{ node }" class="test">
            <div class="selector-custom-item" :class="{ 'unactive': node.status === 2 }" :title="node.status === 2 ? '已过期商品' : ''">
                <span class="selector-custom-item__name" :title="node.name">{{ node.name | cutString(20) }}</span>
                <span class="selector-custom-item__price" :title="node.itemid">
                    <span>￥</span>
                    {{ node.price }}
                </span>
            </div>
        </template>
        <template v-slot:sidebarItem="{ menuItem }">
            <el-badge :value="countMapData[menuItem.id]" :max="99">
                {{ menuItem.name | cutString(10) }}
            </el-badge>
        </template>
    </dialog-selector>
</template>
<script>
    import DialogSelector from '@/components/dialog-selector';
    import UtilsMixins from '@/mixins/utils'
    export default {
        name: 'AsMallItemDialogSelector',
        components: {
            DialogSelector,
        },
        mixins: [UtilsMixins],
        props: {
            groupData: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                selectClassid: null,
                countMapData: {},
            }
        },
        methods: {
            onSelectChange(groupSelectData) {
                const countMapData = {};
                Object.keys(groupSelectData).forEach(key => {
                    const length = groupSelectData[key].selectIds.length;
                    countMapData[key] = length || '';
                })
                this.countMapData = countMapData;
            },
            onClickSidebarItem(item) {
                this.selectClassid = item ? item.id : null;
                if (this.selectClassid === -1) this.selectClassid = null;
                item && this.$refs.dialogSelector.filter();
            },
            filterNode(value, data) {
                if (!value) {
                    return this.selectClassid === null || data.subCategory === this.selectClassid;
                }
                const { name } = data;
                if ( /^[a-zA-Z]+$/.test(value) && window.pinyin) {   
                    let str = window.pinyin(name, {
                        style: window.pinyin.STYLE_FIRST_LETTER
                    }).join('');
                    str = str.toLowerCase();
                    let valStr = value.toLowerCase();
                    let flag = false;
                    if (str.indexOf(valStr) !== -1) flag = true;
                    return flag;
                } 
                return name.indexOf(value) !== -1;
            },
        }
    }
</script>
<style lang="scss">
    .mallitem-dialog-selector {
        .selector-custom-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &.unactive {
                .selector-custom-item__price,
                .dialog-selector__item, 
                .selector-custom-item__name {
                    color: #999;
                }

            }
        }
        .selector-custom-item__price {
            color: #F83051;
        }
        .dialog-selector__item {
            margin-right: 30px;
            flex: 0 0 calc(33.33% - 30px);
        }
    }
</style>